import 'react-app-polyfill/ie11';
import 'core-js/fn/array/find';
import 'core-js/fn/array/find-index';
import 'core-js/fn/array/includes';
import 'core-js/fn/number/is-nan';



// WEBPACK FOOTER //
// ./src/polyfills.js